import Entity from '../entity';
export default class Aircraft extends Entity<string> {
  company: string;
  totalSeats: number;
  maxBaggage: number;
  model: string;
  notes: string;
  fullAircraftName: string;
  isDeleted: boolean;
  deleterUserId: any;
  deletionTime: any;
  lastModificationTime: string;
  lastModifierUserId: number;
  creationTime: string;
  creatorUserId: number;
}
